<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ProductService from '@/services/product';
import Multiselect from 'vue-multiselect'
import { VMoney } from 'v-money'

export default {
  page: {
    title: "Grupos de Adicionais",
  },
  components: { Layout, PageHeader, Multiselect },
  directives: { money: VMoney },
  data() {
    return {
      title: "Grupos de Adicionais",
      complements: [],
      productsComplements: [],
      searchValue: '',
      complement: {},
      modalError: '',
      complementToRemove: '',

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false,
      },
    }
  },
  computed: {
    rows() {
      return this.complements.length;
    }
  },
  mounted() {
    this.load(1);
  },
  methods: {
    async load(page, loader) {
      if (!loader) {
        loader = this.$loading.show();
      }

      try {
        const res = await Promise.all([
          ProductService.getAllComplementsGroups(page, this.searchValue),
          ProductService.getAllComplements(),
        ])
        
        loader.hide();

        this.productsComplements = res[1].data.data;
        this.productsComplements = this.productsComplements.map(item => {
          return {
            ...item,
            full_description: `${item.description} - ${(item.price || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`
          }
        });

        this.complements = res[0].data.data;

        this.count = res[0].data.count;
        this.currentCount = res[0].data.currentCount;
        this.currentPage = res[0].data.currentPage;
        this.totalPages = res[0].data.totalPages;
        this.perPage = res[0].data.perPage;
        this.startIndex = res[0].data.startIndex;
        this.endIndex = res[0].data.endIndex;
      } catch (err) {
        loader.hide();
      }

      ProductService.getAllComplementsGroups(page, this.searchValue).then(res => {
        loader.hide();

        this.complements = res.data.data;

        this.count = res.data.count;
        this.currentCount = res.data.currentCount;
        this.currentPage = res.data.currentPage;
        this.totalPages = res.data.totalPages;
        this.perPage = res.data.perPage;
        this.startIndex = res.data.startIndex;
        this.endIndex = res.data.endIndex;
      }).catch(() => {
        loader.hide();
      })
    },
    inactiveProduct(product) {
      let loader = this.$loading.show();

      const data = {
        _id: product._id,
        active: false,
      }

      ProductService.saveProduct(data).then(() => {
        loader.hide();
        product.active = false;

        this.$toast.open('Adicional inativado')
      }).catch((err) => {
        this.$toast.error(err);
        loader.hide();
      })
    },
    activeProduct(product) {
      let loader = this.$loading.show();

      const data = {
        _id: product._id,
        active: true,
      }

      ProductService.saveProduct(data).then(() => {
        loader.hide();
        product.active = true;

        this.$toast.open('Adicional ativado')
      }).catch((err) => {
        this.$toast.error(err);
        loader.hide();
      })
    },
    newComplement() {
      this.complement = {
        kind: 'multiple',
        price_type: 'add',
      }

      this.modalError = '';

      this.$bvModal.show('modal-edit');
    },
    async saveComplement() {
      this.modalError = '';

      if (!this.complement.description) {
        return this.modalError = 'Informe uma descrição para o produto adicional';
      }

      if (!this.complement.title) {
        return this.modalError = 'Informe uma título para o produto adicional';
      }

      let loader = this.$loading.show();

      const data = {
        ...this.complement,
        values: (this.complement.values || []).map(item => item._id),
      }

      try {
        if (this.complement._id) {
          await ProductService.updateComplementGroup(data);
        } else {
          await ProductService.createComplementGroup(data);
        }

        this.$bvModal.hide('modal-edit');
        this.$toast.open('Dados atualizados com sucesso');

        this.load(1, loader);
      } catch (err) {
        loader.hide();

        const errorData = err.response.data;
        if (errorData.code) {
          if (errorData.code === 'E9999') {
            return this.modalError = errorData.msg;
          }
        }

        this.modalError = 'Ocorreu um erro ao salvar o adicional';
      }
    },
    editComplement(item) {
      const values = this.productsComplements.filter(product => {
        return (item.values || []).includes(product._id);
      })

      this.complement = {
        ...item,
        values,
      }

      this.modalError = '';

      this.$bvModal.show('modal-edit');
    },
    removeComplement() {
      this.$bvModal.hide('modal-remove');      

      let loader = this.$loading.show();

      ProductService.removeComplement(this.productToRemove._id).then(() => {
        this.load(1, loader);
        this.$toast.open('Produto excluído');
      }).catch(() => {
        loader.hide();
        this.$toast.error('Ocorreu um erro ao excluir o registro');
      })
    },
    onPageChange() {
      this.load(this.currentPage + 1);
    },
    search() {
      this.load(1);
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-6">
                <div class="position-relative search-input search-box">
                  <form @submit.prevent="search" class="align-items-center">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchValue"
                      placeholder="Procurar por descrição..."
                    />

                    <button type="submit" class="btn btn-rounded btn-outline-primary ml-2">
                      Pesquisar
                    </button>
                  </form>
                </div>
              </div>
              <div class="col-6">
                <div class="text-right">
                  <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="newComplement">
                    <i class="mdi mdi-plus mr-1"></i> Novo Grupo
                  </button>
                </div>
              </div>
              <!-- end col-->
            </div>
            <!-- Table data -->
            <div class="table-responsive mb-0">
              <table class="table table-centered">
                <thead class="thead-light">
                  <tr>
                    <th>Título no App</th>
                    <th>Descrição</th>
                    <th>Tipo de Seleção</th>
                    <th>Min/Máx de Seleção</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in complements" :key="data._id">
                    <td>{{data.title}}</td>
                    <td>{{data.description}}</td>
                    <td>{{data.kind === 'single' ? 'Único' : 'Múltipla'}}</td>
                    <td>{{data.min_options}}/{{data.max_options}}</td>
                    <td>
                      <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-horizontal font-size-18"></i>
                        </template>

                        <b-dropdown-item @click="editComplement(data)">
                          <i class="fas fa-pencil-alt text-success mr-2 mt-2"></i> Editar
                        </b-dropdown-item>

                        <b-dropdown-divider v-if="data.kind === 'complement'"></b-dropdown-divider>
                        
                        <b-dropdown-item v-if="data.kind === 'complement'" v-b-modal.modal-remove @click="productToRemove = data">
                          <i class="fas fa-trash-alt text-danger mr-2 mt-2"></i> Excluir
                        </b-dropdown-item>    
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>  
            
            <div class="row justify-content-md-between align-items-md-center mt-4">
              <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

              <div class="col-xl-5">
                <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                  <b-pagination
                    v-model="currentPage" 
                    :total-rows="count"
                    :per-page="perPage"
                    @input="onPageChange"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <b-modal id="modal-edit" :title="complement._id ? 'Alterando Grupo de Adicionais' : 'Novo Grupo de Adicionais'" centered size="lg">
      <b-alert v-if="modalError" v-model="modalError" variant="danger" class="mt-0" dismissible>{{modalError}}</b-alert>

      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="title" class="m-0">Título</label>
            <p class="text-muted mb-2 font-size-10">O que será exibido no app</p>
            <input id="title" name="title" type="text" class="form-control" v-model="complement.title" />
          </div>
        </div>

        <div class="col-6">
          <div class="form-group">
            <label for="description" class="m-0">Descrição</label>
            <p class="text-muted mb-2 font-size-10">Para identificar o grupo internamente</p>
            <input id="description" name="description" type="text" class="form-control" v-model="complement.description" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-3">
          <div class="form-group">
            <label for="price_type" class="m-0">Reflexo no Preço</label>
            <select id="price_type" name="price_type" class="form-control" v-model="complement.price_type">
              <option value="add">Acrescentar</option>
              <option value="change">Mudar preço</option>
              <option value="higher">Usar maior valor</option>
            </select>
          </div>
        </div>

        <div class="col-3">
          <div class="form-group">
            <label for="kind" class="m-0">Formato de Seleção</label>
            <select id="kind" name="kind" class="form-control" v-model="complement.kind">
              <option value="multiple">Múltipla</option>
              <option value="single">Única</option>
            </select>
          </div>
        </div>

        <div class="col-3">
          <div class="form-group">
            <label for="min_options" class="m-0">Min. Opções</label>
            <input id="min_options" name="min_options" type="number" class="form-control" v-model="complement.min_options" :disabled="complement.kind === 'single'" />
          </div>
        </div>

        <div class="col-3">
          <div class="form-group">
            <label for="min_options" class="m-0">Máx. Opções</label>
            <input id="min_options" name="min_options" type="number" class="form-control" v-model="complement.max_options" :disabled="complement.kind === 'single'" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label class="control-label">Adicionais </label>
            <multiselect
              v-model="complement.values"
              :options="productsComplements"
              :multiple="true"
              placeholder="Selecione várias opções"
              label="full_description"
              track-by="_id"
              selectLabel="Enter para selecionar"
              selectedLabel="Selecionado"
              deselectLabel="Enter para remover"
              :close-on-select="false"
            ></multiselect>
          </div>
        </div>
      </div>
      
      <template v-slot:modal-footer>
        <b-button variant="link" @click="$bvModal.hide('modal-edit')">Cancelar</b-button>
        <b-button variant="primary" @click="saveComplement()">
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-remove"
      title="Excluir Adicional?"
      title-class="font-18"
      centered
    >
      <p>Confirma a exclusão do produto adicional?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-remove')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="primary" @click="removeComplement">Excluir</b-btn>
      </div>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
  .search-box form {
    display: flex;
    flex-direction: row;
  }

  .search-box .form-control {
    padding-left: 20px;
  }

  .input-search {
    width: 90%;
  }
</style>